<div class="flex--column error container">
  <img class="error__image" alt="inovex Inca Logo" src="assets/images/Inca_Error_Image.svg" />
  <h2 class="error__header">
    {{ 'errors:errors.notFound' | i18next }}
  </h2>
</div>
